import React from 'react';
import { Chip, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faCheckCircle, faExclamationCircle, faClock 
} from '@fortawesome/free-solid-svg-icons';
import { ticketEasyColors } from '../TicketEasyTheme';

interface StatusChipProps {
  status: string;
  size?: 'small' | 'medium';
}

export const StatusChip: React.FC<StatusChipProps> = ({ status, size = 'small' }) => {
  const getStatusDetails = (status: string) => {
    switch(status?.toLowerCase()) {
      case 'new':
        return { 
          icon: faClock, 
          color: ticketEasyColors.psnAccent, 
          bgColor: '#e1f0fa', 
          label: 'New' 
        };
      case 'complete':
        return { 
          icon: faCheckCircle, 
          color: ticketEasyColors.psnGreen, 
          bgColor: '#e2f9eb', 
          label: 'Complete' 
        };
      case 'overdue':
        return { 
          icon: faExclamationCircle, 
          color: ticketEasyColors.psnAlert, 
          bgColor: '#fdedeb', 
          label: 'Overdue' 
        };
      case 'approved':
        return { 
          icon: faCheckCircle, 
          color: ticketEasyColors.psnGreen, 
          bgColor: '#e2f9eb', 
          label: 'Approved' 
        };
      default:
        return { 
          icon: faClock, 
          color: '#95a5a6', 
          bgColor: ticketEasyColors.psnBackground, 
          label: status || 'Unknown' 
        };
    }
  };

  const statusDetails = getStatusDetails(status);

  return (
    <Chip
      icon={<FontAwesomeIcon icon={statusDetails.icon} />}
      label={statusDetails.label}
      size={size}
      sx={{
        bgcolor: statusDetails.bgColor,
        color: statusDetails.color,
        fontWeight: 'bold',
        '& .MuiChip-icon': { color: statusDetails.color }
      }}
    />
  );
};

export const getStatusDetails = (status: string) => {
  switch(status?.toLowerCase()) {
    case 'new':
      return { 
        icon: faClock, 
        color: ticketEasyColors.psnAccent, 
        bgColor: '#e1f0fa', 
        label: 'New' 
      };
    case 'complete':
      return { 
        icon: faCheckCircle, 
        color: ticketEasyColors.psnGreen, 
        bgColor: '#e2f9eb', 
        label: 'Complete' 
      };
    case 'overdue':
      return { 
        icon: faExclamationCircle, 
        color: ticketEasyColors.psnAlert, 
        bgColor: '#fdedeb', 
        label: 'Overdue' 
      };
    default:
      return { 
        icon: faClock, 
        color: '#95a5a6', 
        bgColor: ticketEasyColors.psnBackground, 
        label: status || 'Unknown' 
      };
  }
};
